import * as React from 'react';
import { isMultiHcKoshIntegrationEnabled } from 'feature-flags';
import { AnalyticsContext } from '@atlassian/analytics-web-react';
import { isAdvancedHelpCenter } from '@atlassian/help-center-common-util/advanced-help-center';
import { getHelpCenterAri } from '@atlassian/help-center-common-util/meta';

const HelpCenterAnalyticsContext: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    const attributes = isMultiHcKoshIntegrationEnabled()
        ? {
              helpCenterType: isAdvancedHelpCenter() ? 'custom' : 'default',
              helpCenterAri: getHelpCenterAri(),
          }
        : undefined;

    return <AnalyticsContext attributes={attributes}>{children}</AnalyticsContext>;
};

export default HelpCenterAnalyticsContext;
